<template>
  <div>
    <WCMobileHeaderV2 class="mobile-header" />
    <div
      class="wc-layout wc-layout--mobile-account-subpage"
      :class="!isMultiStore && !$configuration.orderTypesEnabled && 'wc-layout-small-top-position'"
    >
      <WCMobileSearchHeaderBar />
      <div class="wc-layout__body container-fluid" role="main">
        <div class="">
          <router-view />
        </div>
      </div>
      <WCEmployeeAssociationBanner v-if="isEmployee && isCustomer" />
      <WCBottomNavigation v-else-if="!isEmployee" />
    </div>
  </div>
</template>

<script>
import WCBottomNavigation from '@/components/WCBottomNavigation/WCBottomNavigation.vue';
import WCMobileSearchHeaderBar from '@/modules/mobileSearch/components/WCMobileSearchHeaderBar/WCMobileSearchHeaderBar.vue';
import EmployeeMixin from '@/modules/employee/mixins/EmployeeMixin';
import WCEmployeeAssociationBanner from '@/modules/employee/components/WCEmployeeAssociationBanner/WCEmployeeAssociationBanner.vue';
import MobileHeaderHeightMixin from '@/mixins/MobileHeaderHeightMixin';
import WCMobileHeaderV2 from '@/components/WCMobileHeaderV2/WCMobileHeaderV2.vue';

export default {
  name: 'MobileSearchHeader',
  components: {
    WCMobileSearchHeaderBar,
    WCMobileHeaderV2,
    WCBottomNavigation,
    WCEmployeeAssociationBanner,
  },
  mixins: [EmployeeMixin, MobileHeaderHeightMixin],
  computed: {
    /**
     * Property to check if multistore
     */
    isMultiStore() {
      return this.$configuration.multistore;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-layout--mobile-account-subpage {
  position: absolute;
  top: var(--mobile-header-height);
  bottom: rem(10px);
  width: 100%;
  overflow-y: scroll;
  max-height: 100%;
  height: rem(1000px);
  .wc-layout__body {
    padding-bottom: $pad-3 * 3.7;
  }
  &.wc-layout-small-top-position {
    top: $mobile-header-padding-top - 5.4rem;
  }
}
</style>
